// @flow

import { createStore, applyMiddleware, compose } from "redux";
import { routerMiddleware } from "react-router-redux";
import createSagaMiddleware from "redux-saga";
import history from "utils/history";
import rootReducer from "ducks/reducers";
import thunk from "redux-thunk";
import type { Store } from "redux";
import type { State as StoreState, Action } from "ducks/reducers";

const isDev = process.env.NODE_ENV === "development";

export const sagaMiddleware = createSagaMiddleware();

const middleware = applyMiddleware(thunk, sagaMiddleware, routerMiddleware(history));

const devTools =  window.__REDUX_DEVTOOLS_EXTENSION__
  ? window.__REDUX_DEVTOOLS_EXTENSION__()
  : f => f;

const configureStore = (initialState: any): Store<StoreState, Action> => createStore(
  rootReducer,
  initialState,
  ...[isDev ? compose(middleware, devTools) : middleware]
);

export default configureStore();



// WEBPACK FOOTER //
// ./src/store/configureStore.js